// src/components/CustomersList.js

import React from 'react';

function CustomersList({
  customers,
  onSelectCustomer,
  refreshCustomers,
  handleDeleteCustomer,
  handleMarkVerified,
  showDeleted
}) {
  return (
    <div>
      <h2>{showDeleted ? 'Deleted Customers' : 'Active Customers'}</h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {customers.map((cust) => (
          <li key={cust.CustomerID} style={{ margin: '8px 0' }}>
            {cust.IsDeleted ? (
              <span>
                {cust.CompanyName} ({cust.TenantID})
              </span>
            ) : (
              <button
                onClick={() => onSelectCustomer(cust)}
                style={{ marginRight: '10px' }}
              >
                {cust.CompanyName} ({cust.TenantID} | {cust.Email})
              </button>
            )}
            {/* If not deleted, show Delete button */}
            {!cust.IsDeleted && (
              <>
                <button
                  style={{ backgroundColor: 'red', color: 'white' }}
                  onClick={() => handleDeleteCustomer(cust.CustomerID)}
                >
                  Delete
                </button>
                {/* If customer is not verified, show the "Mark as Verified" button */}
                {!cust.IsVerified && (
                  <button
                    style={{ backgroundColor: 'green', color: 'white', marginLeft: '10px' }}
                    onClick={() => handleMarkVerified(cust.CustomerID)}
                  >
                    Mark as Verified
                  </button>
                )}
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default CustomersList;
